var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5197 0.766602L16.2264 3.58974L20.5197 6.41288C23.5292 6.41288 25.9777 8.61606 25.9777 11.6255V11.6921C25.9777 11.6921 25.9777 14.7607 28.8008 14.7607C31.624 14.7607 31.624 11.6921 31.624 11.6921V11.6255C31.624 5.50267 26.6425 0.766602 20.5197 0.766602Z",
    fill: "#8288CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1393 3.58974C19.1393 2.48607 19.6488 1.44422 20.5199 0.766602C14.397 0.766602 9.41553 5.74807 9.41553 11.8709V18.5633L12.2387 21.3864L15.0618 18.5633V11.8709C15.0618 8.86145 17.5103 6.41288 20.5199 6.41288C19.6488 5.73525 19.1393 4.69341 19.1393 3.58974Z",
    fill: "#8288CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6304 17.9492H16.5621V39.234H32.6304C34.2151 39.234 35.4998 37.991 35.4998 36.4577V20.7255C35.4998 19.1923 34.2151 17.9492 32.6304 17.9492Z",
    fill: "#FFB357"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 36.4577V20.7255C19.4316 19.1923 20.7163 17.9492 22.301 17.9492H8.36925C6.78457 17.9492 5.49988 19.1922 5.49988 20.7255V36.4577C5.49988 37.991 6.78457 39.234 8.36925 39.234H22.301C20.7163 39.234 19.4316 37.991 19.4316 36.4577Z",
    fill: "#FFB357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.c8926e19e584d824ca19f5723fc4be04.svg";
export { ForwardRef as ReactComponent };